var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promotionActive)?_c('li',{staticClass:"promo-starting-bonus"},[_c('dyn-slot',{attrs:{"slotData":_vm.slotData}},[_vm._t("dynPromoStartingBonus")],2)],1):(_vm.isActivation)?_c('li',[_vm._t("txtStartingBonusActivation")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }